module.exports = __webpack_public_path__ + "img/Add Vendors.5cee75f7.svg";